import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import { format } from "date-fns";
const OverallandWeeklyTasks = () => {
  const [Load, SetLoad] = useState(false);
  const [OverallQsValues, setOverallQsValues] = useState([]);
  const [WeeklyQs, setWeeklyQs] = useState([]);
  const [monday, setMonday] = useState("");
  const [sunday, setSunday] = useState("");
  const OverallQuestions = async () => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        "/NCLAdmin/GetOverallQCStatusBySubject",
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      const Total = response.data.reduce((acc, curr) => {
        return {
          grade: "Total",
          isTotal: true,
          totalMathsQs: acc.totalMathsQs + curr.totalMathsQs,
          totalMathsQC: acc.totalMathsQC + curr.totalMathsQC,
          totalScienceQs: acc.totalScienceQs + curr.totalScienceQs,
          totalScienceQC: acc.totalScienceQC + curr.totalScienceQC,
          totalEnglishQs: acc.totalEnglishQs + curr.totalEnglishQs,
          totalEnglishQC: acc.totalEnglishQC + curr.totalEnglishQC,
        };
      });
      setOverallQsValues([...response.data, Total]);
      WeeklyQuestions();
    } catch (error) {
      console.error("Error fetching Questions data:", error);
      return [];
    }
  };
  useEffect(() => {
    OverallQuestions();
  }, []);

  const WeeklyQuestions = async () => {
    // SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        "/NCLAdmin/GetWeeklyQuestionsTrackCount",
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      const Total = response.data.reduce((acc, curr) => {
        return {
          grade: "Total",
           isTotal: true,
          totalMathsQs: acc.totalMathsQs + curr.totalMathsQs,
          totalMathsQC: acc.totalMathsQC + curr.totalMathsQC,
          totalScienceQs: acc.totalScienceQs + curr.totalScienceQs,
          totalScienceQC: acc.totalScienceQC + curr.totalScienceQC,
          totalEnglishQs: acc.totalEnglishQs + curr.totalEnglishQs,
          totalEnglishQC: acc.totalEnglishQC + curr.totalEnglishQC,
        };
      });
      setWeeklyQs([...response.data, Total]);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error("Error fetching Questions data:", error);
      return [];
    }
  };
  // useEffect(() => {
  //   WeeklyQuestions();
  // }, []);

  useEffect(() => {
    const now = new Date();
    const dayInWeek = now.getDay();

    const previousMonday = new Date(now.setDate(now.getDate() - dayInWeek - 6));
    const previousSunday = new Date(previousMonday);
    previousSunday.setDate(previousMonday.getDate() + 6);

    setMonday(format(previousMonday, "dd/MMM/yyyy"));
    setSunday(format(previousSunday, "dd/MMM/yyyy"));
  }, []);

  const OverallQsColumns = [
    {
      name: "Grade",
      selector: "grade",
      sortable: true,
      cell: row => (
        <span style={{ fontWeight: row.isTotal ? "800" : "400" }}>
          {row.grade}
        </span>
      ),
    },
    {
      name: "Total Qs Created in Maths",
      selector: "totalMathsQs",
      sortable: false,
    },
    {
      name: "Total Qs QCed in Maths",
      selector: "totalMathsQC",
      sortable: true,
    },
    {
      name: "Total Qs Created in Science",
      selector: "totalScienceQs",
      sortable: false,
    },
    {
      name: "Total Qs QCed in Science",
      selector: "totalScienceQC",
      sortable: true,
    },
    {
      name: "Total Qs Created in English",
      selector: "totalEnglishQs",
      sortable: false,
    },
    {
      name: "Total Qs QCed in English",
      selector: "totalEnglishQC",
      sortable: true,
    },
  ];

  const WeeklyQsColumns = [
    {
      name: "Grade",
      selector: "grade",
      sortable: true,
      cell: row => (
        <span style={{ fontWeight: row.isTotal ? "800" : "400" }}>
          {row.grade}
        </span>
      ),
    },
    {
      name: "Weekly Qs Created in Maths",
      selector: "totalMathsQs",
      sortable: false,
    },
    {
      name: "Weekly Qs QCed in Maths",
      selector: "totalMathsQC",
      sortable: true,
    },
    {
      name: "Weekly Qs Created in Science",
      selector: "totalScienceQs",
      sortable: false,
    },
    {
      name: "Weekly Qs QCed in Science",
      selector: "totalScienceQC",
      sortable: true,
    },
    {
      name: "Weekly Qs Created in English",
      selector: "totalEnglishQs",
      sortable: false,
    },
    {
      name: "Weekly Qs QCed in English",
      selector: "totalEnglishQC",
      sortable: true,
    },
  ];
  return (
    <>
      <div className="SubHeading mt-4">Overall QC Status By Subject</div>
      <DataTable
        data={OverallQsValues}
        columns={OverallQsColumns}
        className="NCLDataTable Card mt-3"
        style={{ marginTop: "40px" }}
         Dropdownvalues={[14, 25, 50, 100]}
        // ShowPagination={true}
        // ShowPagecount={true}
      />
      <div className="SubHeading mt-4">
        Weekly QC Status By Subject ({monday} - {sunday})
      </div>
      <DataTable
        data={WeeklyQs}
        columns={WeeklyQsColumns}
        className="NCLDataTable Card mt-3"
         Dropdownvalues={[14, 25, 50, 100]}
        // ShowPagination={true}
        // ShowPagecount={true}
      />

      {Load && <Loading />}
    </>
  );
};
export default OverallandWeeklyTasks;
